import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import LatestNews from '../news/latestNews';
import TabView from '../tabView/tabView';
import ImageLogo from '../image/imageLogo';
import "../../assets/css/scss/section/_newsTabSection.scss"
import { IPostData } from '../../interfaces/post';
type INewsTabSection = {
    news: IPostData[],
    headlines: IPostData[],
    videos: IPostData[],
    trendings: IPostData[],
}
export default function NewsTabSection(props: INewsTabSection) {
    return (
        <section className="news-section">
            <Container>
                <Row className="justify-content-between">
                    <Col md={6}>
                        <LatestNews news={props?.news} />
                    </Col>
                    <Col md={6} xl={5} className="mt-3 mt-md-0">
                        <div className="theme-medium-gray">
                            <ImageLogo />
                            <TabView headlines={props.headlines} videos={props.videos} trendings={props.trendings} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
